function swatchClick(event, swatch) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();

const productId = swatch.dataset.productId;
const imageUrl = swatch.dataset.image;

const img = document.getElementById('card-image-' + productId);
if (img && imageUrl) {
img.src = imageUrl;
}

document.querySelectorAll('.card-swatch[data-product-id="' + productId + '"]')
.forEach(s => s.classList.remove('is-active'));
swatch.classList.add('is-active');
}